import React, { useState } from 'react';

import './DataProcessing.css';
import imgIntro from '../../assets/images/DataProcessingAgreement/0 Intro.png';
import img1_1 from '../../assets/images/DataProcessingAgreement/1.1 Definitions.png';
import img1_2 from '../../assets/images/DataProcessingAgreement/1.2 Definitions.png';
import img2 from '../../assets/images/DataProcessingAgreement/2 Scope.png';
import img3 from '../../assets/images/DataProcessingAgreement/3 Instructions.png';
import img4 from '../../assets/images/DataProcessingAgreement/4 Personnel.png';
import img5 from '../../assets/images/DataProcessingAgreement/5 Security and Personal Data Breaches.png';
import img6 from '../../assets/images/DataProcessingAgreement/6 Subprocessing.png';
import img7 from '../../assets/images/DataProcessingAgreement/7 Assistance.png';
import img8 from '../../assets/images/DataProcessingAgreement/8 Audit.png';
import img9 from '../../assets/images/DataProcessingAgreement/9 International Data Transfers.png';
import img10 from '../../assets/images/DataProcessingAgreement/10 Compliance.png';
import img11 from '../../assets/images/DataProcessingAgreement/11 Restrictions on Processing.png';
import img12 from '../../assets/images/DataProcessingAgreement/12 Notifications.png';
import img13 from '../../assets/images/DataProcessingAgreement/13 Liability.png';
import img14 from '../../assets/images/DataProcessingAgreement/14 Termination and return or deletion.png';
import img15 from '../../assets/images/DataProcessingAgreement/15 Applicable law and jurisdiction.png';
import img16 from '../../assets/images/DataProcessingAgreement/16 Modification of this DPA.png';
import img17 from '../../assets/images/DataProcessingAgreement/17 Invalidity and severability.png';
import imgAnnexI_1_1 from '../../assets/images/DataProcessingAgreement/ANNEX I 1.1.png';
import imgAnnexI_1_2_1 from '../../assets/images/DataProcessingAgreement/ANNEX I 1.2.1.png';
import imgAnnexI_1_2_2 from '../../assets/images/DataProcessingAgreement/ANNEX I 1.2.2.png';
import imgAnnexI_1_2_3 from '../../assets/images/DataProcessingAgreement/ANNEX I 1.2.3.png';
import imgAnnexI_1_2_4 from '../../assets/images/DataProcessingAgreement/ANNEX I 1.2.4.png';
import imgAnnexI_1_3 from '../../assets/images/DataProcessingAgreement/ANNEX I 1.3.png';
import imgAnnexII_1_1 from '../../assets/images/DataProcessingAgreement/ANNEX II 1.1.png';
import imgAnnexII_1_2 from '../../assets/images/DataProcessingAgreement/ANNEX II 1.2.png';
import imgAnnexII_1_3 from '../../assets/images/DataProcessingAgreement/ANNEX II 1.3.png';
import imgAnnexII_1_4_7 from '../../assets/images/DataProcessingAgreement/ANNEX II 1.4-7.png';
import imgAnnexII_1_8_10 from '../../assets/images/DataProcessingAgreement/ANNEX II 1.8-10.png';
import imgAnnexIII_1_1 from '../../assets/images/DataProcessingAgreement/ANNEX III 1.1.png';
import imgAnnexIII_1_2 from '../../assets/images/DataProcessingAgreement/ANNEX III 1.2.png';
import imgAnnexIII_1_3 from '../../assets/images/DataProcessingAgreement/ANNEX III 1.3.png';

const dataProcessingSections = [
    { title: '1. Definitions', content: [img1_1, img1_2] },
    { title: '2. Scope', content: img2 },
    { title: '3. Instructions', content: img3 },
    { title: '4. Personnel', content: img4 },
    { title: '5. Security and Personal Data Breaches', content: img5 },
    { title: '6. Subprocessing', content: img6 },
    { title: '7. Assistance', content: img7 },
    { title: '8. Audit', content: img8 },
    { title: '9. International Data Transfers', content: img9 },
    { title: '10. Compliance', content: img10 },
    { title: '11. Restrictions on Processing', content: img11 },
    { title: '12. Notifications', content: img12 },
    { title: '13. Liability', content: img13 },
    { title: '14. Termination and return or deletion', content: img14 },
    { title: '15. Applicable law and jurisdiction', content: img15 },
    { title: '16. Modification of this DPA', content: img16 },
    { title: '17. Invalidity and severability', content: img17 },
    {
        title: 'ANNEX I',
        content: [
            imgAnnexI_1_1,
            imgAnnexI_1_2_1,
            imgAnnexI_1_2_2,
            imgAnnexI_1_2_3,
            imgAnnexI_1_2_4,
            imgAnnexI_1_3,
        ],
    },
    {
        title: 'ANNEX II',
        content: [
            imgAnnexII_1_1,
            imgAnnexII_1_2,
            imgAnnexII_1_3,
            imgAnnexII_1_4_7,
            imgAnnexII_1_8_10,
        ],
    },
    {
        title: 'ANNEX III',
        content: [imgAnnexIII_1_1, imgAnnexIII_1_2, imgAnnexIII_1_3],
    },
];

function DataProcessingAgreement() {
    const [expandedSections, setExpandedSections] = useState({});

    const toggleSection = (section) => {
        setExpandedSections((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    return (
        <div className="terms-page data-processing-page">
            <div className="terms-container">
                <h1 className="terms-heading">Data Processing Agreement</h1>
                <img className="data-processing-image" src={imgIntro} alt="" />

                {dataProcessingSections.map((section, sectionIndex) => (
                    <div className="terms-section" key={section.title}>
                        <div
                            className="terms-subheading"
                            onClick={() => toggleSection(sectionIndex)}
                        >
                            <span>{section.title}</span>
                            <span className="symbol">{expandedSections[sectionIndex] ? "−" : "+"}</span>
                        </div>
                        {expandedSections[sectionIndex] && (
                            <div>
                                {(Array.isArray(section.content) ? section.content : [section.content]).map((image, imageIndex) => (
                                    <img
                                        className="data-processing-image"
                                        key={`${section.title}-${imageIndex}`}
                                        src={image}
                                        alt=""
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DataProcessingAgreement;
